mod.modules.define("BaseballCard", function(fn) {

    fn.prototype.init = function (params) {

        //console.log('BaseballCard init');
        var self = this;
        this.issueId = params.wsodIssue;
        
        if ($('#widget-com_baseballcard').length != 0 && $("#addToWatchlistSearchModal_baseball").length != 0) {

            //console.log('elements found');

		    this.$el = $('#widget-com_baseballcard');
		    //console.log('this.$el: ', this.$el);

		    // Find the watchlist modals
		    this.$modalWatchlistAddIssue = $("#addToWatchlistSearchModal_baseball");
		    this.$modalWatchlistCreate = $("#createWatchlistModal_baseball");

            // Removing any pre existing containers
		    $('#WatchlistModalContainer_baseball').remove();

            // Make the temp container and add the modals to it
		    this.$container = $("<div id='WatchlistModalContainer_baseball' />").append(
			    this.$modalWatchlistAddIssue,
			    this.$modalWatchlistCreate
		    ).appendTo("body");

		    this.WatchlistPlugin = mod.modules.create("WatchlistModals", this.$container);

            //attach event handler for button clicks
		    this.$el.find('.baseballcard-footer').on('click', 'button', function (e) {

		        //console.log('.baseballcard-footer clicked');

		        var $el = $(e.target);
		        if (!$el.hasClass('btn')) {
		            $el = $el.parent();
		        }
		        //console.log('$el: ', $el);

		        var action = $el.attr("data-action");
		        //console.log('action: ', action);

		        if (action == "setAlert") {

		            var path = "~/Alerts?symbol=" + $el.attr("data-issue");
		            window.location.href = path.resolveUrl();
		        }
		        else if (action == "addToWatchlist") {

		            var ids = $el.attr("data-watchlistids").split("|");
		            var $modalContent = (ids.length > 0) ? self.$modalWatchlistAddIssue : self.$modalWatchlistCreate;
		            self.WatchlistPlugin.wsodIssue = self.issueId;
		            self.WatchlistPlugin.showModal($modalContent, self.$container);

		            // Hide the baseball card so we don't get funky modal issues
		            self.$el.hide();
		        }
		    });
        } else {
            //console.log('elements ! found');
            //the required elements are not always displayed prior to js code executing,
            //if they are not available wait for them and execute init again, typically only runs once
		    setTimeout(function () { self.init(params) }, 500);
		}
	};

	fn.prototype.dispose = function(removeFromDom) {
		this.base("dispose", removeFromDom);

		this.$container.remove();
	};

    /*
     * This was not working and needs to be reviewed further per VL-68 
     * We are manually attaching the required event for button clicks in the init above

	fn.prototype.events = {
		".baseballcard-readmore": {
			"click": function(e, $el) {
				this.el.find("div.baseballcard-commentary").removeClass("short");
				this.el.find("span.baseballcard-elipsis").remove();
				$el.remove();
			}
		},
		".baseballcard-footer button": {
			"click": function(e, $el) {
				var action = $el.attr("data-action");

				if (action == "setAlert") {
					var path = "~/Alerts?symbol=" + $el.attr("data-issue");
					window.location.href = path.resolveUrl();
				}
				else if (action == "addToWatchlist") {
					var ids = $el.attr("data-watchlistids").split("|");
					var $modalContent = (ids.length > 0) ? this.$modalWatchlistAddIssue : this.$modalWatchlistCreate;
					this.WatchlistPlugin.wsodIssue = this.issueId;
					this.WatchlistPlugin.showModal($modalContent, this.$container);

					// Hide the baseball card so we don't get funky modal issues
					this.el.hide();
				}
			}
		}

	};*/
});